import { render, staticRenderFns } from "./DossierIndex.vue?vue&type=template&id=03a0e68b&scoped=true&"
import script from "./DossierIndex.vue?vue&type=script&lang=js&"
export * from "./DossierIndex.vue?vue&type=script&lang=js&"
import style0 from "./DossierIndex.vue?vue&type=style&index=0&id=03a0e68b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a0e68b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
